export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LfxlTArAAAAABFBPM7X8xQ7LWK2X9jA1PXQFX40',
  },

  // baseUrl: 'https://localhost:7249/api/'
  //baseUrl: 'https://genericdrugsendpayersettlement-staging.azurewebsites.net/api/'
  baseUrl: 'https://www.genericdrugsendpayersettlement.com/api/'

};


